export default __webpack_public_path__ + "static/media/KamiliantbyAmericanTourister.6020057e.jpeg";